<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Basil"><div class="titlepage"><div><div><h1 class="title"><a id="d0e371" xmlns:saxon="http://icl.com/saxon"></a>Basil
                    </h1></div></div></div><p><span class="emphasis"><em>Ocimum
                    basilicum</em></span></p><p class="underline">Chrysippus, the ancient Greek
                champion of stoic </p><p class="underline">theory, reported as early as the third
                century B.C., </p><p class="underline">that “ocimum exists only to drive men
                insane.” </p><p><span class="dropcap">I</span>t’s interesting that a plant as
                benignly loveable as our common sweet basil <span class="emphasis"><em>(Ocimum
                        basilicum)</em></span> developed in such a swirl of historical controversy
                and opposing symbolism. Thought to have originated in India, at least in the form of
                holy basil <span class="emphasis"><em>(Ocimum sanctum),</em></span> basil is also
                incredibly ancient to both Africa and Asia, although the compact bush basil <span class="emphasis"><em>(Ocimum minimum)</em></span> is native to South America
                alone. Basil is thought to have entered Greece with the returning armies of
                Alexander the Great in about 350 B.C., ultimately reaching England and northern
                Europe in the early sixteenth century and the North American continent through the
                earliest Spanish explorers in the late sixteenth century. </p><div class="mediaobject" title="Photo of Basil."><img alt="Photo of Basil." src="images/Basil2.jpg"/><div class="caption"><p>Basil</p></div></div><p>The term
                    <span class="emphasis"><em>basil</em></span> seems to have two possible
                derivations: the first from the terrifying half-lizard, half-dragon <span class="emphasis"><em>basilisk</em></span> of Greek mythology and the second from
                the Greek basilikon, meaning “royal” or “kingly,” in reference to basil’s regal
                scent and royal-purple flower wand. In India, holy basil (<span class="emphasis"><em>tulasi</em></span>) is regarded as sacred, being associated with the
                goddess Tulasi, who, after being tricked by Vishnu into betraying her husband and
                then killing herself, was worshipped ever after for her faithfulness, tulasi
                ultimately becoming a Hindu symbol of love, purity, and protection. </p><p>In
                ancient Greece and Rome, however, it was bizarrely decided that basil would only
                grow well if you shrieked wild curses while sowing the seed, and in France you can
                still hear the phrase <span class="emphasis"><em>semer le basilic,</em></span> which
                translates to “sowing the basil,” meaning “to rant and rave.” Basil also developed
                an equally bizarre reputation for spontaneously generating scorpions as per the
                seventeenth-century French botanist Joseph Pitton de Tournefort: “A certain
                Gentleman of Siena was wont to take the powder of the dry herb and snuff it up his
                nose; but in a short time he turned mad and died; and his head being opened by
                surgeons, there was found a nest of scorpions in his brain.” </p><p>On a lighter,
                amatory note, in old Romania, if a girl presented her beau with a sprig of basil,
                they were officially engaged, and Italian suitors traditionally signaled their love
                by courting with a sprig of basil tucked behind one ear; in many parts of Italy,
                basil still goes by the charming alter ego <span class="emphasis"><em>bacia-nicola,</em></span> or “Kiss-Me-Nicholas.” </p><p>In the end,
                what is one to think? The British herbalist Nicholas Culpeper had a very clear idea
                when, in 1653, he deemed basil “. . . the Herb which all Authors are together by the
                Ears about, and rail at one another like Lawyers.” </p><p>What seems beyond
                contemporary debate, however, is that basil in any of its lovely scented forms is an
                easy-to-grow annual and a seasonal staple in the kitchen. Aside from those
                previously mentioned, some other varieties that may be of interest are the classic
                big-leaved ‘Genovese’ type; the spicy ‘Thai’ variety with a hint of cinnamon; the
                tiny-leaved ‘Globe’, perfect for pot culture; the sprightly ‘Lemon’ or ‘Lime’ types,
                scented with a hint of citrus; and the purple and ruffled varieties like ‘Red
                Rubin’, ‘Opal’, or ‘Purple Ruffles’, which add a becoming flash of color to the
                garden. The latest basil rage is ‘Pesto Perpetuo’ <span class="emphasis"><em>(Ocimum
                        x citriodorum),</em></span> a recently developed hybrid praised for its
                unique variegated, non-flowering, columnar habit, although it’s only available for
                purchase as a plant. </p><div class="mediaobject" title="Photo of basil flower"><img alt="Photo of basil flower" src="images/Basil.jpg"/></div><p>In any case, no
                matter what variety of basil you choose, do sow some seeds or transplant a few
                plants into a nice, sunny position in the garden, keep the flower heads clipped on
                most types, hoard a bit of fresh mozzarella, and wait patiently for the first garden
                tomato and the culinarily <span class="emphasis"><em>ne plus ultra</em></span> of a
                classic Caprese salad. </p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch07.vue?5ea03f7a